import {Injectable} from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {StorageResponse} from '../model/storage-response.model';
import {VehicleStorage} from '../model/storage.model';

@Injectable({providedIn: 'root'})
export class StorageResponseMapper extends Mapper<StorageResponse, VehicleStorage> {
  override map(source: StorageResponse): VehicleStorage {
    return new VehicleStorage(
      source.id,
      source.name,
      source.address);
  }
}
